/**
 * Shared constants across all platforms (Native, Web, etc.)
 */

/**
 * The identifier used for local data created when in Visitor Mode (unauthenticated).
 */
export const VISITOR_ID = "visitor";

/**
 * Standard HTTP Status Codes
 */
export const HTTP_UNAUTHORIZED = 401;
export const HTTP_FORBIDDEN = 403;

/**
 * The slug for the default "Inbox" list.
 */
export const INBOX_SLUG = "inbox";

/**
 * A stable reference for an empty array to prevent unnecessary re-renders in hooks.
 */
export const EMPTY_ARRAY: readonly never[] = Object.freeze([]);

/**
 * Deep Linking Configuration
 */
export const APP_SCHEME = "tendly";
export const APP_DOMAIN = "app.tendly.com";

/**
 * SOFT_DELETE_STANDARD — trash retention window (days). Server purge
 * purga del servidor (`TRASH_PURGE_DAYS`, default 30) elimina definitivamente
 * soft-deleted rows whose `deleted_at` exceeds this threshold. Client
 * uses it ONLY for informative countdown "will be deleted in Y days" in trash
 * view; source of truth for purge is server env (if set to
 * 0 there purge is disabled, but default matches this constant).
 */
export const TRASH_PURGE_DAYS = 30;
